/* Shared by the contact form and /api/contact so both sides accept exactly the same options. */
export const projectTypes = [
    "A single room",
    "Several rooms",
    "A whole home",
    "A design consultation",
    "Something else"
]

export const contactLimits = {
    name: 120,
    email: 254,
    message: 5000,
    messageMin: 10
}
